import { find } from "lodash";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Tag } from "../../App/components/atoms";
import { AdminPage } from "../../App/layout/AdminPage/AdminPage";

const currentMenu = [
  // appendRouteHere

  {
    key: "addReturn",
    label: "add order ",
    link: "/return/addReturn",
  },
];
const currentBreadcrumb = (name: string) => [
  {
    key: "page",
    label: name,
    link: "#",
  },
];

const ReturnPage: React.FC = () => {
  const location = useLocation();
  const [pageName, setPageName] = React.useState<string>("");
  const [breadcrumb, setBreadcrumb] = React.useState<any[]>([]);
  React.useEffect(() => {
    const name = find(currentMenu, ["link", location.pathname]);
    setBreadcrumb(currentBreadcrumb(name?.label || "") || []);
    setPageName(name?.label || "");
  }, [location.pathname]);

  return (
    <AdminPage
      title={
        <div className="admin-page-title">
          Return <Tag>{pageName}</Tag>
        </div>
      }
      breadcrumb={breadcrumb}
    >
      <Outlet />
    </AdminPage>
  );
};

export default ReturnPage;
